import { TableButton } from '@ngx-resource-toolkit/core';
import { Injectable } from '@angular/core';
import { SettingsService } from '../../core/settings/settings.service';


@Injectable()
export class TableButtonsService {

    constructor(private settings: SettingsService) {
    }

    buildButtons(menu, otherButtons = []): TableButton[] {
        const buttons = [];
        if (this.settings.isUserMenuAllowed(menu, 'isSuppression')) {
            buttons.push(TableButton.DELETE);
        }
        if (this.settings.isUserMenuAllowed(menu, 'isLecture')) {
            buttons.push(TableButton.CONSULT);
        }
        if (this.settings.isUserMenuAllowed(menu, 'isModification')) {
            buttons.push(TableButton.EDIT);
        }
        return [...buttons, ...otherButtons];
    }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/services/table-buttons.service.ts